<template>
  <div class="bg-fff pa-t-16 pa-l-56 pa-b-20 width920px user-message">
    <div class="titles-right font-style">我的需求</div>
    <div class="flex f-jcenter">
      <div
        class="ma-r-20 c-pointer"
        @click="
          tabIndex = 0;
          switType();
        "
        :class="tabIndex == 0 ? 'tab-active' : ''"
      >
        国际影展
      </div>
      <div
        class="ma-l-20 c-pointer"
        @click="
          tabIndex = 1;
          switType();
        "
        :class="tabIndex == 1 ? 'tab-active' : ''"
      >
        服务中心
      </div>
    </div>
    <div class="" v-if="tabIndex == 0">
      <div
                class="resource-boxs ma-t-30 height302"
                v-for="(item, index) in newsList"
                :key="index"
                @click="toDetail(item.Id)"
              >
                <div
                  class="t-omit-2 ma-t-10  fon-14 weight500 height40"
                >
                  {{ item.Name }}
                </div>
                <div class="c-8a ma-t-12  fon-12 flex f-between">
                  {{ item.ReleaseTime }}
                </div>
              </div>
      <div v-if="newsList.length == 0">
        <div class="t-center ma-t-40">
          <img src="../img/empty.png" alt="" srcset="" width="200" />
          <div class="c-999">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="flex f-center f-wrap ma-t-40" v-if="tabIndex == 1">
      <div
        class="boxs ma-t-30 height302 ma-r-30"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDetail(item.Id)"
      >
        <img :src="item.Image" class="img_263" />

        <div class="t-omit-2 ma-t-10 pa-lr-10 fon-14 weight500 height40">
          {{ item.Name }}
        </div>
        <div class="c-8a ma-t-12 pa-lr-10 fon-12 flex f-between">
          {{ item.ReleaseTime }}
        </div>
      </div>
      <div v-if="dataList.length == 0" class="width100">
        <div class="t-center ">
          <img src="../img/empty.png" alt="" srcset="" width="200" />
          <div class="c-999">暂无数据</div>
        </div>
      </div>
    </div>
    <div class="t-center ma-t-20">
      <el-pagination
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
        :current-page.sync="queryList.pageIndex"
        :page-size="queryList.pageSize"
        layout="prev, pager, next, jumper"
        :total="totals"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { NewsCollection, getDatumCollectionList } from "../api";
export default {
  name: "mycollect",
  data() {
    return {
      dataList: [],
      newsList: [],
      tabIndex: 0, //0 =》资讯收藏，1=》方案收藏
      queryList: {
        pageIndex: 1,
        pageSize: 10,
        source: "web",
      },
      totals: 0,
    };
  },
  mounted() {
    this.loadDataList();
  },
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    loadDataList() {
      if (this.tabIndex == 0) {
        NewsCollection(this.queryList0).then((res) => {
          this.newsList = res.data.Data.List;
          this.totals0 = res.data.Data.TotalCount;
        });
      } else {
        getDatumCollectionList(this.queryList).then((res) => {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        });
      }
    },
    //类型切换
    switType() {
      this.queryList.pageIndex = 1;
      this.queryList.pageSize = 10;
      this.loadDataList();
    },
    //查看详情
    toDetail(id) {
      if (this.tabIndex == 0) {
        this.$router.push({
          path: "/Study-detail",
          query: { id: id },
        });
      } else {
        this.$router.push({
          path: "/read",
          query: { id: id },
        });
      }
    },
  },
};
</script>

<style >
.resource-boxs{
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 10px;
    cursor: pointer;
  }
.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #fb004d;
  color: #fb004d;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #fb004d;
}
</style>